
  <!-- To Add Action Item Button -->
  <div class="addActionItembutton" *ngIf="isAddButtonVisible">
    <p-button
      appPreventDoubleClick
      styleClass="p-button-outlined"
      id="addActionItemButton"
      class="add-actionItem-button ml-2"
      icon="fa fa-plus"
      iconPos="left"
      pTooltip="Add Action Items"
      tooltipPosition="left"
      (debounceClick)="openActionItemSlider()"
    ></p-button>
  </div>
  <div class="spinner-overlay" *ngIf="showLoader">
    <app-spinner></app-spinner>
  </div>
  <app-panel-list
    [showLoader]="loading()"
    *ngIf="
      ActionPlanData != undefined && isActionPlanDataAvailable
    "
    (selectedItems)="getSelectedItems($event)"
    [panelList]="ActionPlanData"
    [noResultFound]="noData"
    [ifAdditionalItems]="true"
    class="action-Item-panel"
  >  
    <ng-template #templateRef let-data="dataVar">
      <div panel-content>
        <div class="grid">
            <div class="fields-row">
              <div class="actionItemColumn1">
                <app-label labelText="{{ 'Action Item' }}"></app-label>
                <div>
                  <app-read-only
                    readonlyText="{{ data?.actionItem }}"
                  ></app-read-only>
                </div>
              </div>
              <div class="actionItemColumn2 overflow-ellipsis">
                <app-label labelText="{{ 'Status' }}"></app-label>
                <div class="grid pt-1 actionItem-status">
                  <div class="col max-w-0 pb-0">
                    <em
                      class="pi pi-circle-fill ml-1 mr-1 mt-1"
                      [ngClass]="calculateStatusColor(data?.status)"
                    ></em>
                  </div>
                  &nbsp;
                  <div class="col ml-2 pb-0">
                    <app-read-only *ngIf="data?.status != 3"
                      readonlyText="{{ data?.statusName }}"
                    ></app-read-only>
                    <app-read-only  *ngIf="data?.status == 3"
                      readonlyText="{{ data?.statusName }} ({{ data?.completeDate | date : 'dd-MMM-yyyy' }})"
                      ></app-read-only>
                  </div>
                </div>
                <app-read-only  *ngIf="data?.status == 2"
                            readonlyText="(Next - {{ data?.requestedNextStatus}})"
                ></app-read-only>
              </div>
              <div class="column3 notesCol overflow-ellipsis">
                <app-label labelText="{{ 'Due Date' }}"></app-label>
                <app-read-only
                  readonlyText="{{ data?.dueDate | date : 'dd-MMM-yyyy' }}"
                ></app-read-only>
              </div>
              <div class="column4 overflow-ellipsis">
                <app-label labelText="{{ 'Assigned User' }}"></app-label>
                <app-read-only [ngClass]="{'inActiveGroup':data?.assignedUserInfo.isActive===false || data?.assignedUserInfo.isTerminated===true}"
                  readonlyText="{{ data?.assignedUserInfo.assignedUserName }}"
                  toolTipMessage = "{{ data?.assignedUserInfo.assignedUserName }}"
                ></app-read-only>
              </div>
              <div class="column4 overflow-ellipsis">
                <app-label labelText="{{ 'Verifier' }}"></app-label>
                <div class="grid pt-1 actionItem-status">
                  <div class="col ml-2 pb-0">
                    <span  
                      *ngIf="data?.verifier == null" 
                      class="font-semibold readonly">{{'N/A'}}
                    </span>
                    <span  [ngClass]="{'inActiveGroup':data?.verifierInfo.isActive===false || data?.verifierInfo.isTerminated===true}"
                      *ngIf="data?.verifier != null" 
                      class="font-semibold readonly" 
                      pTooltip="{{data?.verifierInfo.assignedUserName}}">{{data?.verifierInfo.assignedUserName}}
                    </span>
                    <span *ngIf="data?.verifier != null && (data?.verifierNotes != null && data?.verifierNotes != undefined && data?.verifierNotes != '' )">
                      <i
                      class="fas fa-comment p-button-rounded p-button-text blue-color comment-icon"
                      pTooltip="{{ data?.verifierNotes}}"
                      >
                      </i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col3">
                <div class="col6">
                  <app-speed-dial [menuItemsData]="SetSpeedDialOptions(data)"></app-speed-dial>
                </div>
              </div>
            </div>

          <!-- Begin: Second Row in Action Plan PanelList -->
          <div class="fields-row">
            <div class="actionItemColumn1">
              <app-label labelText="{{ 'Description' }}"></app-label>
              <app-read-only
                readonlyText="{{ data?.description }}"
              ></app-read-only>
            </div>

            <div class="actionItemColumn2">
              <app-label labelText="{{ 'Type' }}"></app-label>
              <app-read-only
                readonlyText="{{ data?.actionTypeName }}"
              ></app-read-only>
            </div>

            <div class="column3 action-Item-attendee">
              <app-label
                labelText="{{ 'Risk Assessment?' }}"
              ></app-label>
              <app-read-only *ngIf="data?.riskAssesmentRequired == true"
                readonlyText="Yes"
              ></app-read-only>
              <app-read-only *ngIf="data?.riskAssesmentRequired == false"
                readonlyText="No"
              ></app-read-only>
            </div>
            <div class="column3"></div>
            <div class="column4"></div>
            <div class="column5"></div>
          </div>
          <!-- End: Second Row in Action Plan PanelList -->

          <!-- Begin: Third Row in Action Plan PanelList -->
          <div class="fields-row">
            <div class="actionItemActionTaken">
              <app-label labelText="{{ 'Action Taken' }}"></app-label>
              <app-read-only
                readonlyText="{{ data?.actionTaken }}"
                toolTipMessage="{{ data?.actionTaken }}"
              ></app-read-only>
            </div>
          </div>
          <!-- End: Third Row in Action Plan PanelList -->

          <!-- Begin: Fourth Row in Action Plan PanelList -->
          <div class="fields-row">
            <div class="actionItemColumn1">
              <app-label labelText="{{ 'Attachments' }}"></app-label>
              <div
                *ngIf="
                  data?.attachments !== null && data?.attachments.length > 0
                "
                class="col max-w-0 pl-1"
              >
                <em
                  class="pi pi-paperclip blue-color cursor-pointer"
                  (click)="OpenActionItemAttachmentModal(data?.attachments)"
                >
                </em>
              </div>
              <div
                *ngIf="
                  data?.attachments === null || data?.attachments.length === 0
                "
                class="col max-w-0 pl-1 attachmentColumn"
              >
                <app-read-only readonlyText="N/A"></app-read-only>
              </div>
            </div>
          </div>
          <!-- End: Fourth Row in Action Plan PanelList -->
        </div>
      </div>
    </ng-template>
  </app-panel-list>

  <div
    class="displayCenter"
    *ngIf="
      (ActionPlanData == undefined || !isActionPlanDataAvailable) && !showLoader
    "
  >
    <app-empty-results></app-empty-results>
  </div>

<app-action-item-slider
  [changeControlNumber]="changeControlNumber"
  *ngIf="isActionItemSliderOpen"
  [isActionItemSliderOpen]="isActionItemSliderOpen"
  [event]="event"
  [actionItemDetails]="actionItemData"
  (closeActionItemSlider)="closeActionItemSlider()"
  (isSliderActive)="closeSlider($event)"
  (updatedActionPlan)="updatedActionPlan($event)"
  [lastActionItemNumber]="lastActionItemNumber"
  [scopes]="scopes"
>
</app-action-item-slider>

<app-action-plan-attachment
  (attachmentsPopupVisible)="openAttachmentModal($event)"
  [openAttachmentModal]="attachmentsAvailable"
  [attachmentsData]="actionItemAttachments"
></app-action-plan-attachment>

<div *ngIf="isUpdateActionItemModalOpen">
  <app-action-item-modals 
    [actionItemLifeCycleModalValues]="actionItemLifeCycleModalValues" 
    [actionItem]="actionItemData"
    [eventType]="eventType"
    [preFilledReason]="preFilledReason"
    (closeModel)="closeReasonDialogue($event)"
    (actionPlanData)="ActionPlanUpdated($event)"
    >
  </app-action-item-modals>
</div>

<app-action-item-audit-modal *ngIf="showActionItemAuditModal"
[actionItemNumber]="actionItemNumberForAudit"
[isActionItemAuditModalShow]="showActionItemAuditModal"
(showActionItemAuditModal)="closeActionItemAuditModal($event)">
</app-action-item-audit-modal>
